<template>
	<div class="addChild">
		<!-- 父菜谱信息 -->
		<el-card class="card" :key="keyIndex">
			<div class="pageTitle" slot="header">菜谱子菜谱</div>
			<div class="clearfloat">
				<el-form
					ref="mainForm"
					inline
					label-width="120px"
					class="formLeft left"
					:model="form"
					:rules="formRules"
				>
					<el-form-item class="formI" label="产品型号">{{
						escapeValue("productModel", parentInfo.productId)
					}}</el-form-item>
					<el-form-item class="formI" label="菜谱模板">{{
						escapeValue("template", parentInfo.menuTemplateId)
					}}</el-form-item>
					<el-form-item class="formI" label="菜谱ID">{{
						parentInfo.menuId
					}}</el-form-item>
					<el-form-item class="formI" label="菜谱类型">{{
						parentInfo.menuType == 1 ? "常规菜" : "快捷菜"
					}}</el-form-item>
					<el-form-item class="formI" label="菜谱名称">{{
						parentInfo.name
					}}</el-form-item>
					<el-form-item class="formI" label="内置菜">{{
						parentInfo.inner ? "是" : "否"
					}}</el-form-item>
					<el-form-item
						v-if="otherCategoryAChilds.length > 0"
						class="formI"
						:label="otherCategoryA.name"
						>{{
							escapeValue("otherCategoryA", parentInfo.others)
						}}</el-form-item
					>
					<el-form-item class="formI" label="推荐菜">{{
						parentInfo.recommend ? "是" : "否"
					}}</el-form-item>
					<el-form-item
						v-if="foodCategoryChilds.length > 0"
						class="formI"
						:label="foodCategoryInfo.name"
					>
						<div class="categoryItem">
							{{ escapeValue("category", parentInfo.category) }}
						</div>
					</el-form-item>
					<el-form-item class="formI" label="可预约">{{
						parentInfo.order ? "是" : "否"
					}}</el-form-item>
					<!-- 分类 -->
					<el-form-item
						v-if="otherCategoryBChilds.length > 0"
						class="formI"
						:label="otherCategoryB.name"
						>{{
							escapeValue("otherCategoryB", parentInfo.others)
						}}</el-form-item
					>
					<!-- 口味 -->
					<el-form-item
						class="block"
						label="口味"
						ref="flavorError"
						prop="flavor"
					>
						<el-select v-model="form.flavor" placeholder="请选择">
							<el-option
								v-for="item in flavorChilds"
								:key="item.id"
								:label="item.name"
								:value="item.id"
							></el-option>
						</el-select>
					</el-form-item>
					<!-- 份量 -->
					<el-form-item class="block" label="份量">
						<el-select
							multiple
							disabled
							:value="showMeasures"
						></el-select>
						<el-link
							v-if="form.measures.length < 9"
							@click.native="handleAddMeasure"
							type="primary"
							class="marginL10"
							:underline="false"
						>
							新增
						</el-link>
						<el-link
							@click.native="handleSortMeasures"
							type="primary"
							class="marginL10"
							:underline="false"
						>
							排序
						</el-link>
					</el-form-item>
				</el-form>
			</div>
		</el-card>
		<!-- 份量 -->
		<el-tabs class="tabs" v-model="activeTab" type="card">
			<el-tab-pane
				v-for="(item, measureIdx) in form.measures"
				:key="item.people"
				:label="item.people"
				:name="item.people"
			>
				<div>
					<el-button
						type="primary"
						size="small"
						@click="handleEditPeopleName"
					>
						修改名称
					</el-button>
					<el-button
						type="danger"
						size="small"
						@click="handleDeleteMeasure(measureIdx)"
					>
						删除份量
					</el-button>
				</div>
				<!-- 子菜谱 -->
				<el-card class="card">
					<el-form label-width="120px" class="left">
						<el-form-item label="烹饪时间">
							<el-input-number
								:min="0"
								:step="1"
								step-strictly
								class="formInputShort"
								placeholder="请输入"
								v-model.trim="item.hour"
							></el-input-number>
							<span class="inputBack">小时</span>
							<el-input-number
								:min="0"
								:step="1"
								step-strictly
								class="formInputShort marginL10"
								placeholder="请输入"
								v-model.trim="item.minute"
							></el-input-number>
							<span class="inputBack">分钟</span>
						</el-form-item>
						<el-form-item label="步骤简介">
							<el-input
								class="textarea"
								type="textarea"
								rows="3"
								v-model="item.measuresDescribe"
							></el-input>
						</el-form-item>
					</el-form>
				</el-card>
				<Foods
					:ref="'foods' + item.people"
					:foods="item.foods"
					:idenList="idenList"
					@updateFoods="(obj) => updateFoods(obj, measureIdx)"
				></Foods>
				<Parts
					:ref="'parts' + item.people"
					:parts="item.parts"
					@updateParts="(obj) => updateParts(obj, measureIdx)"
				></Parts>
				<!-- 步骤 -->
				<div
					class="steps"
					v-for="(step, index) in steps[item.people]"
					:key="index"
				>
					<!-- 步骤操作 -->
					<div slot="header" class="header clearfloat marginT10">
						<p class="title">步骤{{ index + 1 }}</p>
						<div class="right">
							<el-link
								class="marginR20"
								icon="el-icon-top"
								type="primary"
								@click="
									handleDealSteps('up', index, item.people)
								"
								:disabled="index == 0"
							>
								上移
							</el-link>
							<el-link
								class="marginR20"
								icon="el-icon-bottom"
								type="primary"
								@click="
									handleDealSteps('down', index, item.people)
								"
								:disabled="
									index == steps[item.people].length - 1
								"
							>
								下移
							</el-link>
							<el-link
								icon="el-icon-delete"
								type="danger"
								@click="
									handleDealSteps(
										'delete',
										index,
										item.people
									)
								"
							>
								删除
							</el-link>
						</div>
					</div>
					<Step
						:ref="item.people + 'step' + index"
						:childPropList="childPropList"
						:idenList="idenList"
						:propertes="propertes"
						:stepForm="step"
						:stepIdx="index"
						:stepPeople="item.people"
						class="marginT10"
					></Step>
				</div>
				<!-- 添加按钮 -->
				<el-card
					class="addBtn"
					shadow="hover"
					@click.native="handleDealSteps('add', 0, item.people)"
				>
					<i class="el-icon-plus"></i>
				</el-card>
			</el-tab-pane>
		</el-tabs>
		<!-- 主表单操作栏 -->
		<!-- {{steps}} -->
		<div class="btnBox">
			<el-button @click="handleCancel">取消</el-button>
			<el-button type="primary" @click="beforeSubmit">确认</el-button>
		</div>
		<!-- 排序份量 -->
		<el-dialog title="份量排序" :visible.sync="dialogPeople" width="50%">
			<draggable class="sortDialog" v-model="sortList">
				<el-card
					class="sortCard"
					v-for="item in sortList"
					:key="item.people"
					draggable="true"
				>
					<div>{{ item.people }}</div>
				</el-card>
			</draggable>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogPeople = false">取 消</el-button>
				<el-button type="danger" @click="handleSubSort">
					保 存
				</el-button>
			</div>
		</el-dialog>
		<!-- 修改份量名称 -->
		<el-dialog title="份量重命名" :visible.sync="dialogReName" width="50%">
			<el-input v-model.trim="reName"></el-input>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogReName = false">取 消</el-button>
				<el-button type="danger" @click="handleSubmitReName">
					保 存
				</el-button>
			</div>
		</el-dialog>
		<!-- 新建份量 -->
		<el-dialog
			title="新增份量"
			:visible.sync="dialogNewMeasure"
			width="50%"
			@click="dialogNewMeasure = false"
		>
			<el-input v-model.trim="newMeasureName"></el-input>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogNewMeasure = false">取 消</el-button>
				<el-button type="danger" @click="handleNewMeasure">
					保 存
				</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import Step from "./addChildComp/menuStep";
import Foods from "./addChildComp/foods";
import Parts from "./addChildComp/parts";
import draggable from "vuedraggable";
import { Message } from "element-ui";
export default {
	data() {
		return {
			keyIndex: 0, // 强制重新渲染”步骤“dom结构
			newMeasureName: "", // 新份量名称
			dialogNewMeasure: false,
			childPropList: [],
			formRules: {
				flavor: [
					{
						required: true,
						message: "请选择口味",
						trigger: "blur",
					},
				],
			},
			routeData: {},
			idenList: {
				stepsDescribe: { bounds: "{'size':100}", charcodec: "GBK" }, // 菜谱步骤描述
				beforeDescribe: { bounds: "{'size':100}", charcodec: "GBK" }, // 菜谱启动前描述
				stopDescribe: { bounds: "{'size':100}", charcodec: "GBK" }, // 菜谱步骤暂停中描述
				runningDescribe: { bounds: "{'size':100}", charcodec: "GBK" }, // 菜谱步骤启动中描述
				foodsName: { bounds: "{'size':100}", charcodec: "GBK" }, // 食材名称
				usage: { bounds: "{'size':100}", charcodec: "GBK" }, // 食材用量
				usageMethod: { bounds: "{'size':100}", charcodec: "GBK" }, // 食材用量
			},
			// 食材分类
			foodCategoryInfo: {}, // 食材分类父类详情
			foodCategoryChilds: [], // 食材分类父类详情
			// 口味分类
			flavorInfo: {},
			flavorChilds: [],
			// 其他分类
			otherCategoryA: {}, // 其他分类A详情
			otherCategoryB: {}, // 其他分类B详情
			otherCategoryAChilds: {}, // 其他分类A子分类
			otherCategoryBChilds: {}, // 其他分类B子分类
			// else
			dialogVisible: false,
			dialogPeople: false,
			sortList: [], // 份量排序用列表
			dialogReName: false,
			reName: "",
			propertes: [], // 属性列表
			activeTab: "1人份",
			steps: {},
			parentInfo: {
				productId: "",
				menuTemplateId: "",
				menuId: "",
				menuType: "",
				name: "",
				recommend: "",
				inner: "",
				gourmets: "", //
				order: "",
				features: "",
				category: [],
			},
			form: {
				parentMenu: {
					id: "",
				},
				gourmets: "", //
				audio: "",
				flavor: "",
				measures: [],
			},
		};
	},
	components: { Step, Parts, Foods, draggable },
	computed: {
		showMeasures() {
			let list = [];
			for (let i in this.form.measures) {
				list.push(this.form.measures[i].people);
			}
			return list;
		},
	},
	mounted() {
		let routeData = Object.assign({}, this.$route.params);
		this.routeData = routeData;
		switch (routeData.act) {
			// 编辑
			case "edit":
				let para = Object.assign({}, this.$route.params),
					childInfo = Object.assign({}, this.form),
					steps = {},
					parentInfo = Object.assign({}, this.routeData.parentMenu);
				for (let i in childInfo) {
					childInfo[i] = para[i];
				}
				childInfo.id = para.id;
				childInfo.flavor = para.flavor.id;
				for (let i in para.measures) {
					steps[para.measures[i].people] = para.measures[i].steps;
				}
				this.$set(this, "parentInfo", parentInfo);
				this.$set(this, "form", childInfo);
				this.getStructPropsInfo(steps);
				this.activeTab =
					para.measures.length > 0 ? para.measures[0].people : "";
				break;
			// 添加
			case "add":
				this.form.parentMenu.id = routeData.id; // 关联父菜谱
				this.$set(this, "parentInfo", routeData);
				break;
			// 异常
			default:
				this.$router.replace({
					path: "/menuStandard/validation",
				});
				break;
		}
		// 获取关联数据
		if (routeData.act) {
			this.getProductModels();
			this.getPropertes();
			this.getCategory();
			this.getOtherCategorys();
			this.getFlavor();
		}
		this.getFontsLimit(this.idenList);
	},
	methods: {
		// —————————————————————— 处理步骤 ——————————————————————
		handleDealSteps: function (fun, idx, people) {
			let list = Object.assign([], this.steps[people]),
				comp = null;
			for (let i in list) {
				list[i] = this.$refs[people + "step" + i][0].getData();
			}
			if (fun == "up" || fun == "down") {
				list = this.$utils.handleMoveArr(list, fun, idx);
			} else if (fun == "add") {
				list.push({
					form: {
						stepsType: "", // 步骤类型：0 放料，1 执行，2 结束
						stepsDescribe: "", // 步骤描述（当type为1，describe相当于启动前描述）
						runningDescribe: "", // 以下描述，针对type为1 执行的时候存在
						stopDescribe: "", // 暂停中描述
						stepAudio: "", // 步骤语音描述
						stepImage: "", // 步骤图片名
						menuModelId: "", // 菜谱模型（属性结构体id）
						propertyList: [],
					},
					file: null,
					base64: "",
				});
			} else {
				list.splice(idx, 1);
			}
			this.$set(this.steps, people, list);
			this.keyIndex = this.keyIndex + 1; // 强制重新渲染
			this.$nextTick(() => {
				for (let i in list) {
					this.$refs[people + "step" + i][0].assignForm(list[i]);
				}
			});
		},
		// ——————————————————————食材/器材——————————————————————
		updateFoods(obj, measureIdx) {
			let form = this.$utils.deepClone(this.form);
			form.measures[measureIdx].foods = obj;
			this.$set(this, "form", form);
		},
		updateParts(obj, measureIdx) {
			let form = this.$utils.deepClone(this.form);
			form.measures[measureIdx].parts = obj;
			this.$set(this, "form", form);
		},
		// ——————————————————————份量——————————————————————
		// 新增自定义份量
		handleAddMeasure: function () {
			this.dialogNewMeasure = true;
			this.newMeasureName = "";
		},
		// 确认新增自定义份量
		handleNewMeasure: function () {
			if (
				this.newMeasureName.length < 1 ||
				this.newMeasureName.length > 12
			) {
				Message.error("分类名称长度仅支持1-12位");
				return false;
			}
			for (let i in this.form.measures) {
				if (this.form.measures[i].people == this.newMeasureName) {
					Message.error("已有重名份量");
					return false;
				}
			}
			this.dialogNewMeasure = false;
			this.handleSubMeasure(this.newMeasureName);
		},
		// 新增份量
		handleSubMeasure: function (val) {
			let form = Object.assign({}, this.form);
			// 步骤
			form.measures.push({
				people: val,
				hour: 0,
				minute: 0,
				steps: [
					{
						peopleFlag: "",
						stepsStep: "", // 步骤顺序（2，3，4。。。）步骤从2开始，1为食材展示
						stepsType: "", // 步骤类型：0 放料，1 执行，2 结束
						stepsDescribe: "", // 步骤描述（当type为1，describe相当于启动前描述）
						runningDescribe: "", // 以下描述，针对type为1 执行的时候存在
						stopDescribe: "", // 暂停中描述
						stepAudio: "", // 步骤语音描述
						stepImage: "", // 步骤图片名
						menuModelId: "", // 菜谱模型（属性结构体id）
						propertyList: "", // 属性列表 只有步骤类型为1时才存在“xxx”:{   // 属性id"xxx":”xxx” //属性名:属性值，根据属性类型判断    },
					},
				],
				foods: [],
				parts: [],
				measuresDescribe: "", // 简介
			});
			this.activeTab = val;
			this.$set(this, "form", form);
		},
		// 删除份量
		handleDeleteMeasure: function (idx) {
			this.$confirm(
				"确认删除此份量（" + this.activeTab + "）吗？",
				"提示",
				{
					confirmButtonText: "确定",
					cancelButtonText: "取消",
					type: "warning",
				}
			).then(() => {
				this.form.measures.splice(idx, 1);
				this.activeTab =
					this.showMeasures.length > 0 ? this.showMeasures[0] : "";
			});
		},
		// 排序份量
		handleSortMeasures: function () {
			this.dialogPeople = true;
			this.sortList = Object.assign([], this.form.measures);
		},
		// 提交排序结果
		handleSubSort: function () {
			this.form.measures = Object.assign([], this.sortList);
			this.keyIndex = this.keyIndex + 1;
			this.dialogPeople = false;
		},
		// 编辑分量名
		handleEditPeopleName: function () {
			this.reName = this.activeTab;
			this.dialogReName = true;
		},
		// 重命名份量
		handleSubmitReName: function () {
			let idx = 0;
			if (this.reName.length > 12 || this.reName.length < 1) {
				Message.error("分类名称长度仅支持1-12位");
				return false;
			}
			for (let i in this.form.measures) {
				if (this.form.measures[i].people == this.reName) {
					Message.error("已有重名分类");
					return false;
				} else if (this.form.measures[i].people == this.activeTab) {
					idx = i;
				}
			}
			this.form.measures[idx].people = this.reName;
			this.activeTab = this.reName;
			this.reName = "";
			this.dialogReName = false;
		},
		// —————————————————————— 提交表单 ——————————————————————
		// 提交表单前
		beforeSubmit: function () {
			this.$refs.mainForm.validate((valid) => {
				if (valid) {
					// 步骤数据处理
					let steps = Object.assign({}, this.steps),
						res = {};
					for (let i in steps) {
						for (let x in steps[i]) {
							res = this.$refs[i + "step" + x][0].handleSubmit();
							if (res.result != false) {
								steps[i][x] = {
									stepsStep: Number(x) + 1,
									file: res.file,
									...res.form,
								};
							} else {
								this.positioningError(
									res.stepPeople,
									res.stepIdx
								);
								return false;
							}
						}
					}
					// 图片处理
					let imgFlag = [],
						formData = new FormData();
					for (let i in steps) {
						for (let x in steps[i]) {
							if (steps[i][x].file) {
								imgFlag.push({
									fir: i,
									sec: x,
								});
								formData.append("files", steps[i][x].file);
							}
						}
					}
					this.handleUploadImg(formData, imgFlag, steps);
				} else {
					this.positioningError("flavorError");
				}
			});
		},
		// 上传图片
		handleUploadImg: function (formData, imgFlag, steps) {
			let list = steps;
			if (imgFlag.length > 0) {
				this.$http.uploadFiles(formData).then((res) => {
					if (res.data.success) {
						for (let i in imgFlag) {
							list[imgFlag[i].fir][imgFlag[i].sec].stepImage =
								res.data.data[i];
						}
						this.handleSave(steps);
					}
				});
			} else {
				this.handleSave(steps);
			}
		},
		// 保存表单
		handleSave: function (steps) {
			let para = Object.assign({}, this.form);
			// steps 没有放进表单里面
			let measures = Object.assign([], this.form.measures)
			for (let i in measures) {
				for (let x in steps) {
					if (measures[i].people == x) {
						measures[i].steps = steps[x];
					}
				}
			}
			para.measures = measures;
			let ajax =
				this.routeData.act == "edit"
					? this.$http.singleChildMenusEdit
					: this.$http.singleChildMenusAdd;
			ajax(para).then((res) => {
				if (res.data.success) {
					this.$router.replace({
						path: "/menuStandard/validation",
					});
				}
			});
		},
		// —————————————————————— 关联数据 ——————————————————————
		// 获取产品类型列表
		getProductModels: function () {
			this.$http.productModuleAll().then((res) => {
				if (res.data.success) {
					this.productModels = res.data.data;
					this.getTemplates();
				}
			});
		},
		// 获取菜谱模板
		getTemplates: function () {
			let menuTagId = "";
			for (let i in this.productModels) {
				if (this.productModels[i].id == this.parentInfo.productId) {
					menuTagId = this.productModels[i].menuTagId;
				}
			}
			this.$http.menuTemplatesAll(menuTagId).then((res) => {
				if (res.data.success) {
					this.templates = res.data.data;
				}
			});
		},
		// 获取食材分类父类
		getCategory: function () {
			let para = {
				menuTemplateId: this.parentInfo.menuTemplateId,
			};
			this.$http.categoryTypes(para).then((res) => {
				this.foodCategoryInfo = res.data.data;
				this.getChildsCategory(res.data.data.id, "foodCategoryChilds");
			});
		},
		// 获取其他菜谱分类
		getOtherCategorys: function () {
			let para = {
				menuTemplateId: this.parentInfo.menuTemplateId,
			};
			this.$http.otherCategory(para).then((res) => {
				this.otherCategoryA = res.data.data[0];
				this.otherCategoryB = res.data.data[1];
				this.getChildsCategory(
					res.data.data[0].id,
					"otherCategoryAChilds"
				);
				this.getChildsCategory(
					res.data.data[1].id,
					"otherCategoryBChilds"
				);
			});
		},
		// 获取口味
		getFlavor: function () {
			let para = {
				menuTemplateId: this.parentInfo.menuTemplateId,
			};
			this.$http.flavorTypes(para).then((res) => {
				this.flavorInfo = res.data.data;
				this.getChildsCategory(res.data.data.id, "flavorChilds");
			});
		},
		// 获取其他子分类
		getChildsCategory: function (categoryId, flag) {
			this.$http.menuTypeChildsAll(categoryId).then((res) => {
				this.$set(this, flag, res.data.data);
			});
		},
		// 获取所有属性列表
		getPropertes: function () {
			this.$http
				.productModelFuncListALL({
					productId: this.parentInfo.productId,
				})
				.then((res) => {
					if (res.data.success) {
						let list = [];
						for (let i in res.data.data) {
							if (res.data.data[i].type == 4) {
								list.push(res.data.data[i]);
							}
						}
						for (let i in this.list) {
							list[i].propertyType = list[i].type;
						}
						this.$set(this, "propertes", list);
					}
				});
		},
		// 获取字数限制
		getFontsLimit: function (idenList) {
			let str = this.$utils.handleStrJoint(idenList),
				list = Object.assign({}, this.idenList);
			this.$http
				.getPropInfoByIdentifies({
					productId: this.parentInfo.productId,
					identify: str,
				})
				.then((res) => {
					if (res.data.success) {
						for (let i in res.data.data) {
							list[res.data.data[i].identify] = res.data.data[i];
						}
						this.$set(this, "idenList", list);
					}
				});
		},
		// 获取结构体详情
		getStructPropsInfo: function (steps) {
			let list = [],
				flag = false,
				str = "",
				para = {};
			for (let i in steps) {
				for (let y in steps[i]) {
					for (let x in list) {
						if (list[x] == steps[i][y].menuModelId) {
							flag = true;
						}
					}
					if (!flag) {
						list.push(steps[i][y].menuModelId);
					}
					flag = false;
				}
			}
			for (let i in list) {
				if (list[i] != null) {
					str = str + list[i] + ",";
				}
			}
			para.propertyIds = str;
			if (str.length > 0) {
				this.$http.getPropInfos(para).then((res) => {
					this.$set(this, "childPropList", res.data.data);
					this.$set(this, "steps", steps);
				});
			} else {
				this.$set(this, "steps", steps);
			}
		},
		// —————————————————————— 其他 ——————————————————————
		// 转义数据
		escapeValue: function (type, val) {
			let res = "",
				arr = [];
			switch (type) {
				case "productModel":
					for (let i in this.productModels) {
						if (this.productModels[i].id == val) {
							res = this.productModels[i].productModel;
						}
					}
					return res;
					break;
				case "template":
					for (let i in this.templates) {
						if (this.templates[i].id == val) {
							res = this.templates[i].name;
						}
					}
					return res;
					break;
				case "otherCategoryA":
					for (let i in this.otherCategoryAChilds) {
						for (let x in val) {
							if (
								val[x].subCategoryId ==
								this.otherCategoryAChilds[i].id
							) {
								arr.push(this.otherCategoryAChilds[i]);
							}
						}
					}
					return this.$utils.handleStrJoint(arr, "name");
				case "otherCategoryB":
					for (let i in this.otherCategoryBChilds) {
						for (let x in val) {
							if (
								val[x].subCategoryId ==
								this.otherCategoryBChilds[i].id
							) {
								arr.push(this.otherCategoryBChilds[i]);
							}
						}
					}
					return this.$utils.handleStrJoint(arr, "name");
				case "category":
					if (this.routeData.act == "add") {
						for (let i in val) {
							// 来自父菜谱创建完成后
							if (typeof val[i] === "number") {
								for (let x in this.foodCategoryChilds) {
									if (
										val[i] == this.foodCategoryChilds[x].id
									) {
										arr.push(this.foodCategoryChilds[x]);
									}
								}
							}
							// 来自列表创建
							else {
								arr.push({ name: val[i].name });
							}
						}
					} else {
						for (let i in this.foodCategoryChilds) {
							for (let x in val) {
								if (val[x] == this.foodCategoryChilds[i].id) {
									arr.push(this.foodCategoryChilds[i]);
								}
							}
						}
					}
					return this.$utils.handleStrJoint(arr, "name");
				default:
					return "--";
			}
		},
		// 取消添加子菜谱
		handleCancel: function () {
			this.$router.replace({
				path: "/menuStandard/validation",
			});
		},
		// 跳转到异常位置
		positioningError: function (type, idx) {
			let refName =
					type == "flavorError" ? "flavorError" : type + "step" + idx,
				dom = this.$refs[refName];
			// 切换tab
			if (type != "flavorError") {
				this.activeTab = type;
			}
			this.$nextTick(() => {
				if (Object.prototype.toString.call(dom) !== "[object Object]") {
					dom = dom[0];
				}
				dom.$el.scrollIntoView({
					block: "center",
					behavior: "smooth",
				});
			});
		},
	},
};
</script>
<style lang="less" scoped>
@import "../style/addChild.less";
</style>